import { PartnerInvestmentRecord } from "../models/partnerInvestment";

export interface PartnerInvestmentSummary {
	totalInvested: number;
	totalOutstanding: number;
	activeCount: number;
	partnerBreakdown: Record<string, number>;
}

export const calculatePartnerInvestmentSummary = (
	investments: PartnerInvestmentRecord[],
	// optional current item list to derive runtime status
	items?: Array<any>
): PartnerInvestmentSummary => {
	const isConsumed = (investment: PartnerInvestmentRecord) => {
		if (!items) return investment.status === "consumed";
		if (investment.status === "settled") return false;
		if (!investment.itemLinks || investment.itemLinks.length === 0)
			return false;
		// An investment is only considered consumed once each linked item has no stock left.
		return investment.itemLinks.every((link) => {
			const item = items.find((it) => it.key === link.itemKey);
			// if item missing, assume not consumed
			if (!item) return false;
			return (item.availableQuantity || 0) === 0;
		});
	};

	const activeInvestments = investments.filter(
		(investment) =>
			investment.status !== "settled" && !isConsumed(investment)
	);
	const partnerBreakdown = activeInvestments.reduce<Record<string, number>>(
		(acc, investment) => {
			const partnerName =
				investment.fundingSource === "shopCash"
					? "Stock funded by Shop"
					: investment.partnerName?.trim() || "Unknown Partner";
			acc[partnerName] = (acc[partnerName] || 0) + investment.amount;
			return acc;
		},
		{}
	);

	return {
		totalInvested: investments.reduce(
			(sum, investment) => sum + investment.amount,
			0
		),
		totalOutstanding: activeInvestments.reduce(
			(sum, investment) => sum + investment.amount,
			0
		),
		activeCount: activeInvestments.length,
		partnerBreakdown
	};
};
